export const Instagram = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 4.55556C1 2.59189 2.59189 1.00001 4.55555 1.00001V1.00001H13.4444V1.00001C15.4081 1.00001 17 2.59189 17 4.55558V13.4444C17 15.4081 15.4081 17 13.4444 17V17H4.55555V17C2.59188 17 1 15.4081 1 13.4444L1 4.55556Z"
        stroke="currentColor"
      />
      <circle cx="9" cy="9" r="3.5" stroke="currentColor" />
      <circle cx="14" cy="4" r="1" fill="currentColor" />
    </svg>
  )
}
